

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaHeadset,
  FaCalendarAlt
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Dashboard = ({ admin }) => {
  const { role, email } = admin || {};
  const navigate = useNavigate();


  const [totalStudents, setTotalStudents] = useState(0);
  const [totalClasses, setTotalClasses] = useState(0);
  const [totalSupport, setTotalSupport] = useState(0);
  const [openExams, setOpenExams] = useState([]);
  // const [loading, setLoading] = useState(true);

    const [visibleCount, setVisibleCount] = useState(20);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const classRes = await axios.get("https://api.scannscore.com/class");
        const classList = classRes.data;
        setTotalClasses(classList.length);

        let totalStudentCount = 0;
        let allOpenExams = [];

        for (let cls of classList) {
          const studentRes = await axios.get(`https://api.scannscore.com/student/${cls.id}`);
          totalStudentCount += studentRes.data.length;

          const examRes = await axios.get(`https://api.scannscore.com/get_exam/${cls.id}`);
          const open = examRes.data.filter((exam) => exam.status === "open");
          allOpenExams.push(...open);
        }

        setTotalStudents(totalStudentCount);
        setOpenExams(allOpenExams);

        const supportRes = await axios.get("https://api.scannscore.com/inquiry");
        setTotalSupport(supportRes.data.length);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  const visibleExams = openExams.slice(0, visibleCount);

  useEffect(() => {
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    if (scrollTop + windowHeight >= docHeight - 100) {
      loadMore();
    }
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, [openExams, visibleCount]);


const loadMore = () => {
  if (loadingMore) return;
  if (visibleCount >= openExams.length) return;

  setLoadingMore(true);

  setTimeout(() => {
    setVisibleCount((prev) => prev + 10);
    setLoadingMore(false);
  }, 300);
};

useEffect(() => {
  setVisibleCount(20);
}, [openExams]);


  const displayedEmail = (role === "admin" || role === "teacher") ? email : "";

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h2 className="dashboard-title">Dashboard</h2>
        {displayedEmail && (
          <p className="user-email">Logged in as: {displayedEmail}</p>
        )}
      </header>

      <div className="info-cards">
        <div className="card card-students" onClick={() => navigate("/admin/student")}>
          <div className="card-left">
            <h4>Total Students</h4>
            <h2>{loading ? "..." : totalStudents}</h2>
          </div>
          <div className="card-icon"><FaUserGraduate /></div>
        </div>

        <div className="card card-classes" onClick={() => navigate("/admin/classes")}>
          <div className="card-left">
            <h4>Total Classes</h4>
            <h2>{loading ? "..." : totalClasses}</h2>
          </div>
          <div className="card-icon"><FaChalkboardTeacher /></div>
        </div>

        <div className="card card-support" onClick={() => navigate("/admin/inquiry")}>
          <div className="card-left">
            <h4>Total inquiry</h4>
            <h2>{loading ? "..." : totalSupport}</h2>
          </div>
          <div className="card-icon"><FaHeadset /></div>
        </div>
      </div>

      <div className="section-header">
        <h3 className="section-title">
          <FaCalendarAlt style={{ marginRight: "10px" }} /> Upcoming Exams
        </h3>
      </div>

      {visibleExams.length === 0 ? (
        <div className="empty-state">
          <p>{loading ? "Loading data..." : "No open exams available."}</p>
        </div>
      ) : (
        <div className="exam-table">
          <div className="exam-row exam-header">
            <div className="col-name">Name</div>
            <div className="col-questions">Questions</div>
            <div className="col-status">Status</div>
          </div>

          {visibleExams.map((exam, idx) => (
            <div key={idx} className="exam-row">
              <div className="col-name">{exam.name || exam.exam_title}</div>
              <div className="col-questions">{exam.questions?.length || 0}</div>
              <div className="col-status">
                <span className="status-badge">{exam.status}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      <style jsx>{`
        .dashboard-container {
          padding: 30px;
          background-color: #f8fafc;
          min-height: 100vh;
          font-family: 'Inter', sans-serif;
        }

       .dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;  /* allow items to wrap on small screens */
  margin-bottom: 40px;
}

        .dashboard-title {
          font-size: 28px;
          font-weight: 800;
          margin: 0;
        }

    .user-email {
  font-size: 14px;
  color: #555;
  word-break: break-all;      /* Break long words/emails */
  max-width: 100%;            /* Make sure it doesn't overflow */
  overflow-wrap: anywhere;    /* Helps on very long emails */
  margin-top: 4px;
}
        .info-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 25px;
          margin-bottom: 50px;
        }

        .card {
          padding: 24px;
          border-radius: 20px;
          color: white;
          cursor: pointer;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 150px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25),
                      0 6px 6px rgba(0, 0, 0, 0.20),
                      0 -4px 10px rgba(0,0,0,0.15),
                      4px 0 10px rgba(0,0,0,0.15),
                      -4px 0 10px rgba(0,0,0,0.15);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .card:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 25px rgba(0,0,0,0.3),
                      0 8px 8px rgba(0,0,0,0.25),
                      0 -6px 12px rgba(0,0,0,0.2),
                      6px 0 12px rgba(0,0,0,0.2),
                      -6px 0 12px rgba(0,0,0,0.2);
        }

        .card-students { background: linear-gradient(135deg, #6366f1, #a855f7); }
        .card-classes { background: linear-gradient(135deg, #0ea5e9, #22c55e); }
        .card-support { background: linear-gradient(135deg, #f59e0b, #ef4444); }

        .card-left {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 6px;
          width: 100%;
          text-align: left;
        }

        .card-left h4 { margin: 0; font-size: 14px; font-weight: 600; }
        .card-left h2 { margin: 0; font-size: 36px; font-weight: 800; }

        .card-icon {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 28px;
          background: rgba(255,255,255,0.2);
          width: 64px;
          height: 64px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .section-title { font-size: 20px; font-weight: 700; margin-bottom: 15px; }

        .exam-table {
          background: white;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 10px 20px rgba(0,0,0,0.15), 0 6px 6px rgba(0,0,0,0.10);
          overflow: hidden;
          transition: box-shadow 0.3s ease;
        }

        .exam-table:hover {
          box-shadow: 0 15px 25px rgba(0,0,0,0.2), 0 8px 8px rgba(0,0,0,0.15);
        }

        .exam-row {
          display: flex;
          padding: 12px 20px;
          border-bottom: 1px solid #e5e7eb;
          align-items: center;
        }

        .exam-header {
          background-color: #f1f5f9;
          font-weight: 600;
        }

        .exam-row:nth-child(even) {
          background-color: #f9fafb;
        }

        .col-name { flex: 2 1 180px; text-align:center; }
        .col-questions { flex: 3 3 380px; text-align: center; }
        .col-status { flex: 4 1 80px; text-align: center; }

        .status-badge {
          background: #22c55e;
          color: white;
          padding: 2px 8px;
          border-radius: 6px;
          font-size: 12px;
        }

        .empty-state {
          padding: 30px;
          text-align: center;
          color: #94a3b8;
        }

        @media (max-width: 768px) {
          .info-cards { grid-template-columns: 1fr; }
        }
      `}</style>
    </div>
  );
};

export default Dashboard;
